<div class="ip-no-data__not-found">
  <app-ip-empty-data [msgText]="getMsgText()"></app-ip-empty-data>
</div>